import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import SeasonSelect from "../SeasonSelect";
import {useTranslation} from "react-i18next";

export const useToolbar = (availableSeasons) => {
    const sortedSeason = availableSeasons.sort((a, b) => b - a);

    const [selectedSeason, setSelectedSeason] = useState(sortedSeason?.[0] ?? null);

    useEffect(() => {
        setSelectedSeason(sortedSeason?.[0] ?? null);
    }, [availableSeasons]);

    return {
        selectedSeason,
        setSelectedSeason,
    }
}

const Toolbar = (props) => {
    const {t} = useTranslation("graphs");
    const {
        selectedSeason,
        setSelectedSeason,
        availableSeasons
    } = props;

    return <Grid container sx={{py: 4}}>
        <Grid item xs={12} >
            <SeasonSelect selectedSeason={selectedSeason}
                          setSelectedSeason={setSelectedSeason}
                          sx={{minWidth: "9rem"}}
                          label={t("hsGraph.season")}
                          availableSeasons={availableSeasons}
            />
        </Grid>
    </Grid>
}

export default Toolbar;